import React from 'react';
import Carousel from "nuka-carousel";
import {
  getAdBannerByDomainAction
} from "../../../../Store/actions";
import {useSelector, useDispatch} from "react-redux";
import { getImageUrl } from "../../../../Utils/index";

export default function Slider() {

  const dispatch = useDispatch();

const {adBanners} = useSelector((state) => state.Website);

  React.useEffect(()=>{
      dispatch(getAdBannerByDomainAction());
  }, [dispatch])

 
        const items = React.useMemo(()=>{
    let arr = [];
    adBanners?.forEach((i)=> {
      if(i.banner_dimension == "1480 * 630"){let obj = {};
            obj.src = getImageUrl(i.image_upload);
            obj.url = i.image_url;
            obj.altText = "ad";
            arr.push(obj);}
    });
    return arr;
  }, [adBanners])

  return(
    <div id="slider-index2" className='cursor-pointer'>
    <Carousel> 
      {items.map((o)=>{
        return(
  <img onClick={()=>window.open(o?.redirect_url, "_blank")}
  id="slider-img-s" src={o.url || o.src} alt={o.alt}
  loading="lazy"
  style={{width:"100%"}}/>
  )
      })}
  </Carousel>
   </div>
)
}